export default __webpack_public_path__ + "static/media/klima.14622a83.jpg";